module.exports = __webpack_public_path__ + "img/1551893058.900dc4b7.jpg";